import React from 'react';
import {
    HelperText,
    Regular
} from '@worthy-npm/clarity';
import {shapesData, colorsData, clarityData} from "constants/calculator";
import {isMobile} from 'helpers/ApplicationHelper';

class CalcControllers extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            size: props.size || '--',
            shape: props.shape || '',
            color: props.color || '',
            clarity: props.clarity || ''
        }

        this.caratRef = React.createRef()
        this.isMobile = isMobile()
    }

    componentDidMount(){
        this.caratRef.current.value = this.state.size === '--'? 0.25 : parseFloat(this.state.size)
    }

    updateProp(key, val){
        if(key === 'size') {val= parseFloat(val)}
        this.setState({[key]: val})
        this.props.updateValue({...this.state, [key]: val})
    }

    render(){
        return (
            <div className='calculator-controllers'>
                <div className='controller-container carat-slider'>
                    <div className='top d-flex flex-align-center'>
                        <HelperText overrideCSS={{textAlign: 'left'}} text='Carat'/>
                        <Regular text={this.state.size} overrideCSS={{fontSize: '14px'}}/>
                    </div>
                    <input ref={this.caratRef} type="range" min="0.25" max="5" step="0.05" className="slider"
                            onChange={(event)=>{this.setState({size: event.target.value})}}
                            onTouchEnd={(event)=>{this.updateProp('size', event.target.value)}}
                            onMouseUp={(event)=>this.updateProp('size', event.target.value)}/>
                </div>
                <div className='controller-container'>
                    <HelperText overrideCSS={{textAlign: 'left', marginBottom: '5px'}} text='Shape'/>
                    <div className='shapes labels-container'>
                    {
                        shapesData.map((shape, i)=>{
                            return <div key={i} onClick={()=>this.updateProp('shape', shape)}
                                                className={`label-container d-flex flex-align-center flex-justify-center W-100
                                                    ${shape === this.state.shape? 'selected' : ''}`}>
                                    <div className='label-inner d-flex flex-align-center flex-justify-center'>
                                        <Regular text={shape} overrideCSS={{fontSize: '14px'}}/>
                                    </div>
                                </div>
                        })
                    }
                    </div>
                </div>
                <div className='controller-container'>
                    <HelperText overrideCSS={{textAlign: 'left', marginBottom: '5px'}} text='Color'/>
                    <div className='colors labels-container'>
                    {
                        colorsData.map((color, i)=>{
                            return <div key={i} onClick={()=>this.updateProp('color', color)}
                                                className={`label-container d-flex flex-align-center flex-justify-center W-100
                                                    ${color === this.state.color? 'selected' : ''}`}>
                                    <div className='label-inner d-flex flex-align-center flex-justify-center'>
                                        <Regular text={color} overrideCSS={{fontSize: '14px'}}/>
                                    </div>
                                </div>
                        })
                    }
                    </div>
                </div>
                <div className='controller-container'>
                    <HelperText overrideCSS={{textAlign: 'left', marginBottom: '5px'}} text='Clarity'/>
                    <div className='clarities labels-container'>
                    {
                        clarityData.map((clarity, i)=>{
                            return <div key={i} onClick={()=>this.updateProp('clarity', clarity)}
                                                className={`label-container d-flex flex-align-center flex-justify-center W-100
                                                    ${clarity === this.state.clarity? 'selected' : ''}`}>
                                    <div className='label-inner d-flex flex-align-center flex-justify-center'>
                                        <Regular text={clarity} overrideCSS={{fontSize: '14px'}}/>
                                    </div>
                                </div>
                        })
                    }
                    </div>
                </div>
            </div>
        );
    }
}

export default CalcControllers;